<script>
export default {
  name: 'SessionOpenPlacesMixin',
  computed: {
    currentSessionIsPrivate() {
      return this.currentSession.is_private;
    },
    maxParticipantsAmount() {
      return this.currentSession.participant_preferences.max_participants_amount;
    },
    maxObserversAmount() {
      return this.currentSession.participant_preferences.max_observers_amount;
    },
    openParticipantsPositions() {
      return this.currentSession.open_participant_position;
    },
    openObserversPositions() {
      return this.currentSession.open_observer_position;
    },
  },
};
</script>
